import { useDispatch } from 'react-redux';
import { AnonUserCriteria } from 'modules/graphql/types/GraphQLAnonymousCriteria';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { TOAST_ACTIONS } from '../constants';
import { useEditCriteria } from './useEditCriteria';

export const useEditCriteriaDescription = (criteria: AnonUserCriteria) => {
  const dispatch = useDispatch();
  const { editCriteria } = useEditCriteria();

  const editCriteriaDescription = (description: string, onCompleted?: () => void) => {
    editCriteria({
      variables: {
        id: criteria.id,
        criteria: {
          ...criteria.fields,
          description,
        },
      },
      onCompleted: (data) => {
        if (data?.updateAnonUserCriteria?.failure?.message) {
          dispatch(
            addNegativeToastWithErrorId(
              data?.updateAnonUserCriteria?.failure?.message,
              TOAST_ACTIONS.editDescription,
              new Error(data?.updateAnonUserCriteria?.failure?.message),
            ),
          );
        } else {
          dispatch(
            addPositiveToast(
              <>
                Description for <strong>{criteria.fields.name}</strong> updated successfully.
              </>,
            ),
          );
          onCompleted?.();
        }
      },
      onError: (e) => {
        dispatch(
          addNegativeToastWithErrorId(
            <>
              Error updating description for <strong>{criteria.fields.name}</strong>. Please try
              again.
            </>,
            TOAST_ACTIONS.editDescription,
            e,
          ),
        );
      },
    });
  };

  return {
    editCriteriaDescription,
  };
};
